import { render, staticRenderFns } from "./indemnisation.vue?vue&type=template&id=0ce5576e"
import script from "./indemnisation.vue?vue&type=script&lang=ts"
export * from "./indemnisation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports